/**
 *
 * Table
 *
 */
import StyleComponentProps from 'core/utils/types/StyleComponentProps';
import React, { memo, ReactNode } from 'react';
import {
  PaginationState,
} from '@tanstack/react-table';

import { DynamicTable } from './DynamicTable';
import { StaticTable } from './StaticTable';
import { NewDynamicTable } from './NewDynamicTable';

interface Props extends StyleComponentProps {
  columns: any[];
  data: any[];
  onRowClick?: any;
  hoverTransparent?: boolean;
  pageIndex?: number;
  pageSize?: number;
  defaultColumns?: {
    minSize: number;
    maxSize: number;
  };
  manualShowingFrom?: number;
  manualShowingTo?: number;
  setPagination?: React.Dispatch<React.SetStateAction<PaginationState>>;
  notWantPages?: boolean;
  previousYearValidationNotRequired?: boolean;
  totalEntries: number;
  dispatch?: any;
  route?: string;
  selectedClass?: number;
  columnsSelectionDispatch?: any;
  defaultColumnsForSelectection?: any;
  customData?: any;
  headerControls?: () => ReactNode;
  headerControlsLeft?: () => ReactNode;
  className?: string;
  examName?: string;
  handleFeedbackCheckboxToggle?: any;
}



export const Table = memo((props: Props) => {
  return !!props?.dispatch ? <NewDynamicTable {...props} /> : <StaticTable {...props} />
});
